import styled from 'styled-components';
import type { Presence } from './liveClient';
const Mirror = styled.div`
  position: absolute;
  inset: 1px;
  overflow: hidden;
  pointer-events: none;
  border-radius: inherit;
  [data-cursor-text] {
    padding: 12px;
    color: transparent;
  }
  [data-caret] {
    position: relative;
    border-left: 2px solid ${({ theme }) => theme.color.accentCyan};
    margin-left: -2px;
  }
  [data-caret]::after {
    content: attr(data-caret);
    position: absolute;
    bottom: 100%;
    left: 0;
    background: ${({ theme }) => theme.color.accentCyan};
    color: ${({ theme }) => theme.color.onAccent};
    padding: 1px 4px;
    border-radius: 3px;
    font-size: 10px;
    white-space: nowrap;
  }
  mark {
    color: transparent;
    background: ${({ theme }) => theme.color.accentCyan}24;
  }
`;
export function LiveCursors({
  body,
  peers,
  version,
  scrollTop,
}: {
  body: string;
  peers: Presence[];
  version: number;
  scrollTop: number;
}) {
  const chars = Array.from(body),
    visible = peers.filter((p) => p.version === version && p.head != null && p.anchor != null);
  const boundaries = [
    ...new Set([0, chars.length, ...visible.flatMap((p) => [p.head!, p.anchor!])]),
  ]
    .filter((n) => n >= 0 && n <= chars.length)
    .sort((a, b) => a - b);
  return (
    <Mirror aria-hidden="true">
      <div data-cursor-text style={{ transform: `translateY(${-scrollTop}px)` }}>
        {boundaries.map((start, i) => {
          const end = boundaries[i + 1] ?? start;
          const selected = visible.some(
            (p) =>
              start >= Math.min(p.anchor!, p.head!) &&
              end <= Math.max(p.anchor!, p.head!) &&
              end > start,
          );
          return (
            <span key={start}>
              {visible
                .filter((p) => p.head === start)
                .map((p) => (
                  <span key={p.clientId} data-caret={p.person.name} />
                ))}
              {selected ? (
                <mark>{chars.slice(start, end).join('')}</mark>
              ) : (
                chars.slice(start, end).join('')
              )}
            </span>
          );
        })}
        {'\u200b'}
      </div>
    </Mirror>
  );
}
